// feature toggle implementation (https://martinfowler.com/bliki/FeatureToggle.html)

import pairedMap from './pairedMap';

export default (features = {}) =>
  (...args) =>
    pairedMap(([featureName, checkers]) => {
      const checkResult = checkers.every((checker) => {
        if (typeof checker === 'function') {
          checker = checker(...args);
        }

        return checker === true;
      });

      return [featureName, checkResult];
    })(features);
